/**
 * Create/manage in-flight async requests
 * @module
 */
var actionTypes = require('../constants/action_types');
var Flux = require('../flux');
var PromiseEnv = require('../lib/promise').Promise;

var di = require('../di');
var AsyncRequestStore = di.get('stores/async_request');

/**
 * Make a request if we haven't already done so for the given `source` key.
 *
 * @param {string} source
 * @param {function} [requestFn] Called if this is the first invocation of makeAsyncRequest with the given `source`.
 * @returns {Promise}
 */
exports.makeAsyncRequest = function(source:string, requestFn?:Function): Promise<any> {
  var inFlightRequest = AsyncRequestStore.getPromise(source);
  if (inFlightRequest) {
    return inFlightRequest;
  }

  var resolver, rejecter;

  var promise = new PromiseEnv(function(resolve, reject) {
    resolver = resolve;
    rejecter = reject;
  });

  Flux.dispatch(actionTypes.REGISTER_ASYNC_DEFERRED, {
    source: source,
    promise: promise,
    resolver: resolver,
    rejecter: rejecter,
  });

  // Call the requestFn. When it loads it can call dfd.resolve or the API method v1.dataFromSource with the same
  // source as this call in order to resolve the deferred.
  if (requestFn) {
    requestFn();
  }

  return promise;
};

/**
 * Resolve a previously-registered request
 * @param {string} source
 * @param {*} [resolveWith]
 */
exports.resolveRequest = function(source:string, resolveWith?:any) {
  Flux.dispatch(actionTypes.RESOLVE_DEFERRED, {
    source: source,
    resolveWith: resolveWith,
  });
};

/**
 * Reject a previously-registered request
 * @param {string} source
 * @param {*} [rejectWith]
 */
exports.rejectRequest = function(source:string, rejectWith?:any) {
  Flux.dispatch(actionTypes.REJECT_DEFERRED, {
    source: source,
    rejectWith: rejectWith,
  });
};
